import { mobileBreakpoint, createCustomCards } from '@helpers/helpers';

export default function () {
  const widgetName = 'faigroundsCardsWidget';
  const widgetOpts = faigroundsCardsWidgetOpts;
  const $widgetHTML = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($widgetHTML, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: true,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function (data) {
      const cards = $(`#${widgetName} .card-widget-item`);
      if (cards.length > 0) {
        createCustomCards(data, cards);
      } else {
        $widgetHTML.remove();
      }
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: mobileBreakpoint ? ['all'] : [''], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 4,
    moreButton: {
      visible: true,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: false,
  });
}
